import { render } from "./UsahaPerikanan.vue?vue&type=template&id=6a676f57"
import script from "./UsahaPerikanan.vue?vue&type=script&lang=js"
export * from "./UsahaPerikanan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__